import { render } from "./NavbarMenuItem.vue?vue&type=template&id=514b0e6b"
import script from "./NavbarMenuItem.vue?vue&type=script&lang=js"
export * from "./NavbarMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__